export const CURRENCY_CHOICES = ['PKR', 'USD', 'AED', 'EUR', 'GBP'];
export const CATEGORY_CHOICES = [
  'Office Supplies',
  'Utility Bills',
  'Office Maintenance & Repair',
  'Entertainment',
  'Electrical & IT Equipment',
  'Office Furniture',
  'Office Vehicles',
  'Petty Expenses',
  'Travel',
  'Food',
  'Marketing',
  'Salaries',
  'IT Services',
  'Consulting',
  'Other',
  'Payroll',
];

export const STATUS_CHOICES = ['Pending', 'Approved', 'Rejected'];

export const TABLE_HEAD = [
  { id: 'name', label: 'Name', alignRight: false },
  { id: 'category', label: 'Category', alignRight: false },
  { id: 'amount', label: 'Amount', alignRight: false },
  { id: 'currency', label: 'Currency', alignRight: false },
  { id: 'date', label: 'Date', alignRight: false },
  { id: 'remarks', label: 'Remarks', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: false },
];

export const getInitialExpenseFormData = () => ({
  name: '',
  amount: '',
  category: '',
  currency: 'PKR',
  date: new Date().toISOString().split('T')[0], // Today's date in YYYY-MM-DD format
  status: 'Approved',
  remarks: '',
  money_account: '',
});

export const getExpenseFormDataFromRecord = (expense) => ({
  name: expense.name || '',
  amount: expense.amount?.toString() || '',
  category: expense.category || '',
  currency: expense.currency || 'PKR',
  date: expense.date || '',
  status: expense.status || 'Approved',
  remarks: expense.remarks || '',
  money_account: expense.money_account || '',
});

export const formatExpenseDataForSubmission = (formData) => ({
  name: formData.name.trim(),
  amount: parseFloat(formData.amount) || 0,
  category: formData.category,
  currency: formData.currency,
  date: formData.date,
  status: formData.status,
  remarks: formData.remarks.trim(),
  money_account: formData.money_account || null,
});
